import React from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { useTranslation } from 'react-i18next'

/* shown over the unified login screen after a no-entitlement sign-out;
   MUI Dialog because the lib's login backdrop sits at z-index 9999 (the app modal is z-index 101) */
const NoAccessModal = ({ open, onClose }) => {
	const [t] = useTranslation()
	return (
		<Dialog open={open} onClose={onClose} sx={{ zIndex: 10000 }}>
			<DialogTitle>{t('modal_headers.error')}</DialogTitle>
			<DialogContent>
				<DialogContentText>{t('auth_screen.error.no_access')}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>{t('auth_screen.button.close')}</Button>
			</DialogActions>
		</Dialog>
	)
}

export default NoAccessModal
